import { render, staticRenderFns } from "./ChargeTransactionsModal.vue?vue&type=template&id=28daba63&scoped=true"
import script from "./ChargeTransactionsModal.vue?vue&type=script&lang=js"
export * from "./ChargeTransactionsModal.vue?vue&type=script&lang=js"
import style0 from "./ChargeTransactionsModal.vue?vue&type=style&index=0&id=28daba63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28daba63",
  null
  
)

export default component.exports